export default "__VITE_ASSET__CTnEDZVc__"